module.exports = __webpack_public_path__ + "static/media/story_02.9236ae0a.jpg";